import { render, staticRenderFns } from "./GeographicStatisticsAll.vue?vue&type=template&id=7c89a197&scoped=true"
import script from "./GeographicStatisticsAll.vue?vue&type=script&lang=js"
export * from "./GeographicStatisticsAll.vue?vue&type=script&lang=js"
import style0 from "./GeographicStatisticsAll.vue?vue&type=style&index=0&id=7c89a197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c89a197",
  null
  
)

export default component.exports